import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultsComponent } from './components/results/results.component';
import { FormComponent } from './components/form/form.component';
import { HomeComponent } from './components/home/home.component';
import { BadRequestComponent } from './components/error-pages/bad-request/bad-request.component';
import { ServerErrorComponent } from './components/error-pages/server-error/server-error.component';
import { CompanyComponent } from './components/company/company.component';
import { ThanksComponent } from './components/form/thanks.component';
import { ThanksOnholdComponent } from './components/onhold/thanks-onhold/thanks-onhold.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: ':company',
    children: [
      {
        path:'', component: CompanyComponent
      },
      {
        path: 'inquire/:code/:codeAvailability',
        children: [
          { path: '', component: FormComponent },
          { path: 'charter/:type', component: FormComponent },
          { path: 'fit/:type', component: FormComponent }
        ]
      },
      {
        path: 'onhold/:code/:codeAvailability',
        children: [
          { path: '', component: FormComponent },
          { path: 'charter/:type', component: FormComponent },
          { path: 'fit/:type', component: FormComponent }
        ]
      },
      {
        path: ':boat/:days/:daterange/:paxs',
        children: [
          { path: '', component: ResultsComponent },
          { path: ':promo', component: ResultsComponent }
        ]
      },
      {
        path: ':code',
        children: [
          { path: 'thanks', component: ThanksComponent },
          { path: 'thanks-onhold', component: ThanksOnholdComponent }
        ]
      }
    ]
  },
  { path: 'error/400', component: BadRequestComponent },
  { path: 'error/500', component: ServerErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
